export const materials = [
    {
        id: 1,
        name: "Տեխնոլոգիա և ձեռնարկչություն",
        info: "Դիտել",
        file: "../../files/technology/materials/1.pdf",
        menuItemId: 2
    },

];

